// ============================================================
// หน้า Employee — รายชื่อผู้ใช้ทั้งหมด
// ------------------------------------------------------------
// จัดการผู้ใช้ระบบ: เพิ่ม / แก้ไข / เปลี่ยนรหัสผ่าน / ลบ
// ผู้ใช้ 1 คนผูกได้หลายโครงการ (เลือกจากรายการฝั่งขวาของ popup)
//
// กติกาชื่อผู้ใช้/รหัสผ่าน: ตัวอักษรอังกฤษกับตัวเลขเท่านั้น รหัสผ่านอย่างน้อย 4 ตัว
// ============================================================

import React, { Component } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { loading, tokens, select_style, success, GET, POST, PUT, DELETE, gen_password, number, validate, required, alert, getStorage, permission, Paginate, ActionIcon, ConfirmModal, ICON } from "../../shared/index.js";

const perm = permission("employee");

// ประเภทผู้ใช้
const USER_OPTS = [
  { value: "admin", label: "พนักงานทั่วไป" },
  { value: "finance", label: "พนักงานการเงิน" },
  { value: "project_manager", label: "ผู้จัดการประจำโครงการ" },
  { value: "center_manager", label: "ผู้จัดการกลาง" },
];

// ชื่อผู้ใช้/รหัสผ่าน รับเฉพาะตัวอักษรอังกฤษและตัวเลข
const ALPHANUMERIC = /^[a-zA-Z0-9]+$/;
const MIN_PASSWORD_LENGTH = 4;

const TABLE_HEADERS = ["รหัสสมาชิก", "ชื่อ-นามสกุล", "เบอร์โทร", "ประเภท", "บทบาท", "โครงการ"];

export default class Employee extends Component {
  state = this.initState();

  initState() {
    return {
      // popup
      modal_create: false,
      modal_update: false,
      modal_delete: false,
      modal_password: false,
      modal_detail: false,
      // ตัวกรอง
      page: 1,
      filter_data_search: "",
      filter_user_type: null,
      search_project: "", // ค้นหาในรายการโครงการของ popup
      // ข้อมูล
      data: null,
      data_project: [],
      data_role: [],
      // ฟอร์ม
      user_id: "",
      username: "",
      password: "",
      user_type: null,
      role_id: null,
      full_name: "",
      address: "",
      phone: "",
      pin_number: "",
      project_list: [],
    };
  }

  async componentDidMount() {
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.fetchRoles(), this.fetchProjects(), this.fetchData()]);
    loading(false);
  }

  // ---------- โหลดข้อมูล ----------

  fetchRoles = async () => {
    const result = await GET(tokens, "v1/TH/role-manage/filter-search/page/0?data_search=", null);
    if (result?.status) this.setState({ data_role: result.data.data.map((e) => ({ value: e.role_id, label: e.role_name })) });
  };

  fetchProjects = async () => {
    const result = await GET(tokens, "v1/TH/project-manage/filter-search/page/0?data_search=", null);
    if (result?.status) this.setState({ data_project: result.data.data });
  };

  fetchData = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/user-admin/filter-search/page/${this.state.page}/${getStorage("project_id")}`, {
      data_search: this.state.filter_data_search,
      user_type: this.state.filter_user_type?.value || "",
    });
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // ---------- บันทึก / ลบ ----------

  // ตรวจรูปแบบชื่อผู้ใช้/รหัสผ่าน — คืน true เมื่อผ่าน
  validateCredentials = (isNew) => {
    const { username, password } = this.state;
    if (isNew && !ALPHANUMERIC.test(username)) return alert("warning", "แจ้งเตือน", "ชื่อผู้ใช้ต้องประกอบด้วยตัวอักษรและตัวเลขเท่านั้น");
    if (password.length < MIN_PASSWORD_LENGTH) return alert("warning", "แจ้งเตือน", `รหัสผ่านต้องมีความยาวอย่างน้อย ${MIN_PASSWORD_LENGTH} ตัวอักษร`);
    if (!ALPHANUMERIC.test(password)) return alert("warning", "แจ้งเตือน", "รหัสผ่านต้องประกอบด้วยตัวอักษรและตัวเลขเท่านั้น");
    return true;
  };

  // บันทึกผู้ใช้
  //   isCreate   = true เพิ่มใหม่ / false แก้ไข
  //   isPassOnly = true คือแก้เฉพาะรหัสผ่าน (ตรวจแค่ช่องรหัสผ่าน)
  handleSave = async (isCreate, isPassOnly = false) => {
    const requiredFields = isPassOnly ? ["password"] : ["user_type", "role_id", "full_name", "phone", "project_list"];
    if (isCreate) requiredFields.push("username", "password");
    if (validate(this.state, requiredFields) || !this.validateCredentials(isCreate)) return;

    loading(true);
    const { user_id, username, password, user_type, role_id, full_name, address, phone, pin_number, project_list } = this.state;
    const payload = { user_id, username, password, user_type: user_type?.value || "", role_id: role_id?.value || "", full_name, address, phone, pin_number, project_list };

    const result = await (isCreate ? POST : PUT)(tokens, `v1/TH/user-admin/${isCreate ? "create" : "update"}`, payload);
    if (result?.status) this.afterSave();
    loading(false);
  };

  handleDelete = async () => {
    loading(true);
    const result = await DELETE(tokens, `v1/TH/user-admin/delete/${this.state.user_id}`, null);
    if (result?.status) this.afterSave();
    loading(false);
  };

  // ล้างฟอร์มแล้วโหลดข้อมูลใหม่ทั้งหมด
  afterSave = () => {
    this.setState(this.initState(), () => {
      this.fetchRoles();
      this.fetchProjects();
    });
    success();
    this.fetchData();
  };

  // ---------- ฟอร์ม ----------

  // เปิด popup แก้ไข (type = "modal_update") หรือเปลี่ยนรหัสผ่าน (type = "modal_password")
  // พร้อมติ๊กโครงการที่ผู้ใช้คนนี้มีอยู่แล้ว
  openModal = (item, type) => {
    const projects = this.state.data_project.map((d) => ({ ...d, selected: item.project_list.some((e) => e.project_id === d.project_id) }));
    this.setState({
      [type]: true,
      data_project: projects,
      user_id: item.user_id,
      username: item.username,
      password: item.password,
      user_type: USER_OPTS.find((o) => o.value === item.user_type) || null,
      role_id: this.state.data_role.find((e) => e.value === item.role_id) || null,
      full_name: item.full_name,
      address: item.address,
      phone: item.phone,
      pin_number: item.pin_number,
      project_list: item.project_list.map((e) => e.project_id),
    });
  };

  // ติ๊กเลือกโครงการใน popup
  toggleProject = (project_id, checked) => {
    const projects = [...this.state.data_project];
    projects.find((p) => p.project_id === project_id).selected = checked;
    this.setState({ data_project: projects, project_list: projects.filter((p) => p.selected).map((p) => p.project_id) });
  };

  // ช่องกรอกในฟอร์ม
  //   type = "tel" รับเฉพาะตัวเลข
  //   withGenerate = true จะมีปุ่มสุ่มรหัสผ่าน 8 ตัวข้างช่อง
  renderField = (label, field, type = "text", maxLength = null, disabled = false, withGenerate = false) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">
        {label}
        {required}:
      </label>
      <input
        className="form-control border-0 bg-contain validate"
        type={type}
        maxLength={maxLength}
        disabled={disabled}
        value={this.state[field]}
        onChange={(e) => this.setState({ [field]: type === "tel" ? number(e.target.value) : e.target.value })}
      />
      {withGenerate && (
        <button className="btn btn-blue text-white ml-2" onClick={async () => this.setState({ [field]: await gen_password(8) })}>
          Generate
        </button>
      )}
    </div>
  );

  closeFormModal = () => this.setState({ modal_create: false, modal_update: false });

  render() {
    const s = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="รายชื่อผู้ใช้ทั้งหมด" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ + ปุ่มเพิ่ม */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>รายชื่อผู้ใช้ทั้งหมด</b>
                </h4>
                {perm.create && (
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_create: true, data_project: s.data_project.map((d) => ({ ...d, selected: false })) })}>
                    เพิ่มผู้ใช้งาน
                  </button>
                )}
              </div>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <input
                      type="search"
                      className="form-control wpx-200 bg-contain border-0 mx-1 mb-3"
                      placeholder="พิมพ์คำค้นหา..."
                      value={s.filter_data_search}
                      onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                    />
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <Select
                        className="form-control bg-contain border-0 select-search"
                        styles={select_style}
                        placeholder="ทุกประเภท"
                        options={[{ value: "", label: "ทุกประเภท" }, ...USER_OPTS]}
                        onChange={(e) => this.setState({ filter_user_type: e })}
                        isClearable
                        value={s.filter_user_type}
                      />
                    </div>
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.fetchData)}>
                      ค้นหา
                    </button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_data_search: "", filter_user_type: null, page: 1 }, this.fetchData)}>
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* ตารางผู้ใช้ */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {TABLE_HEADERS.map((h, i) => (
                        <th key={i} className="text-left">
                          {h}
                        </th>
                      ))}
                      {(perm.update || perm.delete) && <th className="text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? (
                      <tr>
                        <td colSpan={7} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      s.data.data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.user_code || "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td>{item.phone || "-"}</td>
                          <td>{USER_OPTS.find((opt) => opt.value === item.user_type)?.label || "ทุกประเภท"}</td>
                          <td>{item.role_name || "-"}</td>
                          <td>
                            <label className="pointer" onClick={() => this.setState({ modal_detail: true, project_list: item.project_list })}>
                              ดูรายละเอียดเพิ่มเติม
                            </label>
                          </td>
                          {(perm.update || perm.delete) && (
                            <td className="text-center d-flex">
                              {perm.update && (
                                <>
                                  <ActionIcon color="success" icon={ICON.key} title="เปลี่ยนรหัสผ่าน" className="mr-2" onClick={() => this.openModal(item, "modal_password")} />
                                  <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => this.openModal(item, "modal_update")} />
                                </>
                              )}
                              {perm.delete && <ActionIcon color="danger" icon={ICON.delete} title="ลบ" onClick={() => this.setState({ modal_delete: true, user_id: item.user_id })} />}
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={s.data} page={s.page} onChange={(value) => this.setState({ page: value }, this.fetchData)} />
            </div>
          </div>
        </div>

        {/* popup เพิ่ม / แก้ไขผู้ใช้ (ใช้ฟอร์มเดียวกัน) */}
        <Modal show={s.modal_create || s.modal_update} onHide={this.closeFormModal} dialogClassName="modal-w">
          <Modal.Header>
            <Modal.Title>
              <b>{s.modal_create ? "เพิ่มผู้ใช้งาน" : "แก้ไขผู้ใช้งาน"}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {/* ซ้าย — ข้อมูลผู้ใช้ (Username/รหัสผ่าน ตั้งได้เฉพาะตอนเพิ่มใหม่) */}
              <div className="col-12 col-lg-6">
                {this.renderField("ชื่อ-นามสกุล", "full_name")}
                {this.renderField("เบอร์โทร", "phone", "tel", 10)}
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140">ประเภทผู้ใช้{required}:</label>
                  <Select className="form-control bg-contain border-0 select-search" options={USER_OPTS} styles={select_style} placeholder="ทุกประเภท" isClearable value={s.user_type} onChange={(e) => this.setState({ user_type: e })} />
                </div>
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140">บทบาท{required}:</label>
                  <Select className="form-control bg-contain border-0 select-search" styles={select_style} options={s.data_role} value={s.role_id} onChange={(e) => this.setState({ role_id: e })} />
                </div>
                {s.modal_create && (
                  <>
                    {this.renderField("Username", "username")}
                    {this.renderField("รหัสผ่าน", "password", "text", null, false, true)}
                  </>
                )}
              </div>

              {/* ขวา — เลือกโครงการที่ผู้ใช้เข้าถึงได้ */}
              <div className="col-12 col-lg-6">
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140">โครงการ:</label>
                  <input type="search" className="form-control w-100 bg-contain border-0 mx-1" placeholder="พิมพ์คำค้นหา..." value={s.search_project} onChange={(e) => this.setState({ search_project: e.target.value })} />
                </div>
                <small>โครงการที่เลือก {s.data_project.filter((item) => item.selected).length} โครงการ</small>
                <div className="w-100 overflow-auto mb-3" style={{ minHeight: "50vh", height: "50vh" }}>
                  <table className="table table-borderless table-striped">
                    <tbody>
                      {!s.data_project.length && (
                        <tr>
                          <td colSpan={2} className="text-center">
                            ไม่มีข้อมูล
                          </td>
                        </tr>
                      )}
                      {s.data_project
                        .filter((item) => item.project_name.includes(s.search_project))
                        .map((item, index) => (
                          <tr key={index}>
                            <td>{item.project_name || "-"}</td>
                            <td>
                              <input type="checkbox" checked={item.selected || false} onChange={(e) => this.toggleProject(item.project_id, e.target.checked)} />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={this.closeFormModal}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => this.handleSave(s.modal_create)}>
                  {s.modal_create ? "เพิ่ม" : "บันทึก"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup เปลี่ยนรหัสผ่าน */}
        <Modal show={s.modal_password} onHide={() => this.setState({ modal_password: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>แก้ไขรหัสผ่าน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderField("ชื่อ-นามสกุล", "full_name", "text", null, true)}
            {this.renderField("รหัสผ่าน", "password", "text", null, false, true)}
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_password: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => this.handleSave(false, true)}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ยืนยันการลบ */}
        <ConfirmModal
          show={s.modal_delete}
          title="ยืนยันการลบผู้ใช้งาน"
          message="ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้"
          footerClassName="w-100 d-flex mt-3"
          onCancel={() => this.setState({ modal_delete: false })}
          onConfirm={this.handleDelete}
        />

        {/* popup ดูรายชื่อโครงการของผู้ใช้ */}
        <Modal show={s.modal_detail} onHide={() => this.setState({ modal_detail: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>รายชื่อโครงการ</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-borderless table-striped">
              <tbody>
                {s.project_list.map((item, index) => (
                  <tr key={index}>
                    <td>{item.project_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="w-100 mt-3">
              <button className="btn btn-primary w-100" onClick={() => this.setState({ modal_detail: false })}>
                ปิด
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
